import React from 'react'
import { Link as GLink } from 'gatsby'
import { Heading } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'

const CardBodyTitle = ({ variant, title, slug, link, linkTitle }) => {
  const linkProps = link
    ? {
        as: 'a',
        title: linkTitle || title,
        href: link,
        ...(String(link).match(/www.(staging.)?togetherprice.com/) ? {} : {
          target: '_blank',
          rel: 'noopener noreferrer'
        })
      }
    : {
        as: GLink,
        to: slug,
        title: linkTitle || title,
      }
  return (
    <Heading as='h1' sx={{ variant: rv(variant, 'title') }}>
      <Heading {...linkProps} sx={{ variant: rv(variant, 'title') }}>
        {title}
      </Heading>
    </Heading>
  )
}

export default CardBodyTitle
